import { render, staticRenderFns } from "./audios.vue?vue&type=template&id=73723c04&"
import script from "./audios.vue?vue&type=script&lang=js&"
export * from "./audios.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports